import React from 'react'

interface ShortTextIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ShortTextIcon: React.FC<ShortTextIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 15,
  alt = 'ShortText icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 15'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M1.25 1.25v3.5h7.5v-3.5h-7.5zM1 0a1 1 0 00-1 1v4a1 1 0 001 1h8a1 1 0 001-1V1a1 1 0 00-1-1H1zm.25 10.25v3.5h21.5v-3.5H1.25zM1 9a1 1 0 00-1 1v4a1 1 0 001 1h22a1 1 0 001-1v-4a1 1 0 00-1-1H1zm13.25-4.25v-3.5h8.5v3.5h-8.5zM13 1a1 1 0 011-1h9a1 1 0 011 1v4a1 1 0 01-1 1h-9a1 1 0 01-1-1V1z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default ShortTextIcon
